export const encodeBase64 = objectURL => {
  return new Promise(resolve => {
    fetch(objectURL).then(response =>
      response.blob().then(blob => {
        const reader = new window.FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const data = reader.result;
          resolve(data);
        };
      }),
    );
  });
};
